<template>
  <div class="definition" @click="setAnswer">
    <div class="body">
      <img :src="definition.imageUrl" class="image" v-if="definition.imageUrl">
      <audio-button :src="definition.audioUrl" class="audio" v-if="definition.audioUrl"></audio-button>
      <h5>
        {{definition.term}} <i class="alt-term" v-if="definition.altTerm">- {{ definition.altTerm }}</i>
      </h5>
      <p class="sample">{{definition.sample}}</p>
    </div>
  </div>
</template>

<script>
  import AudioButton from "@/components/_global/audio-button"

  export default {
    name: 'vocabDefinition',
    props: {
      value: Number,
      definition: Object
    },
    components: { AudioButton },
    data () {
      // To test image & alt term
      //
      // this.definition.imageUrl = 'http://95b2.http.cdn.softlayer.net/8095B2/content.studysync.com.s3-website-us-east-1.amazonaws.com/eld/06.01.10.RD.RR.05.Hatchet/positive.jpg'
      // this.definition.altTerm = 'En Espanish'
      // this.definition.audioUrl = 'https://www.sample-videos.com/audio/mp3/crowd-cheering.mp3'
      return {}
    },
    methods: {
      setAnswer () {
        this.$emit("input", this.definition.id)
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  h5 {
    @include font-size(small, $headline:true);
    margin-bottom:1rem;
  }

  .sample {
    margin:0; line-height:1.3;
  }

  .body {
    overflow:hidden; margin-bottom:1.5rem;
  }

  .image {
    width:75px; height:75px; float:left; margin-right:1rem;
  }

  .alt-term {
    font-size:80%;
  }
  .audio {
    float:right;
  }

</style>



// WEBPACK FOOTER //
// src/components/VisualVocab/definition.vue